// https://www.w3.org/TR/2019/NOTE-wai-aria-practices-1.1-20190207/examples/menu-button/js/Menubutton2.js

import A11yPopup from './a11y-popup'

export default function A11yPopupButton(node) {
  this.node = node
  this.active = false
  this.popup = false
}

A11yPopupButton.prototype.init = function () {
  this.initPopup()
  this.node.addEventListener('click', this.togglePopup.bind(this))
}

A11yPopupButton.prototype.initPopup = function () {
  const popup = document.getElementById(this.node.getAttribute('aria-controls'))

  if (popup) {
    this.popup = new A11yPopup(popup, this)

    if (
      this.node.getAttribute('aria-expanded') &&
      this.node.getAttribute('aria-expanded') == 'true'
    ) {
      this.popup.open()
    }
  }
}

A11yPopupButton.prototype.closePopup = function (focus = true) {
  ;[
    ...document.querySelectorAll(
      `[aria-controls='${this.node.getAttribute('aria-controls')}']`,
    ),
  ].forEach((element) => {
    element.setAttribute('aria-expanded', 'false')
  })
  this.popup.close(focus)
  this.active = false
}

A11yPopupButton.prototype.togglePopup = function () {
  if (this.node.getAttribute('aria-expanded') == 'true') {
    ;[
      ...document.querySelectorAll(
        `[aria-controls='${this.node.getAttribute('aria-controls')}']`,
      ),
    ].forEach((element) => {
      element.setAttribute('aria-expanded', 'false')
    })

    this.popup.close(true)
    this.active = false
  } else {
    ;[
      ...document.querySelectorAll(
        `[aria-controls='${this.node.getAttribute('aria-controls')}']`,
      ),
    ].forEach((element) => {
      element.setAttribute('aria-expanded', 'true')
    })

    this.popup.open()
    this.active = true

    if (this.node.getAttribute('data-a11y-focus')) {
      document.querySelector(this.node.getAttribute('data-a11y-focus')).focus()
    }
  }
}
